module.exports = __webpack_public_path__ + "static/media/full-logo.0c3b1f49.png";